import {FormikHelpers} from "formik";
import {getFlatKeys} from "./common";

export function HandleErrors(res: any, helpers: FormikHelpers<any>) {

    if (res.validation_errors) {
        let keys = Object.keys(res.validation_errors)
        for (let i = 0; i < keys.length; i++) {
            helpers.setFieldError(keys[i], res.validation_errors[keys[i]][0])
        }
        if (keys.length) {
            focusInputElementByName(keys[0]);
        }
        return true
    }
    return false;
}

export function focusOnError(errors: Array<any>) {
    const keys = getFlatKeys(errors);
    if (keys.length) {
        focusInputElementByName(keys[0]);
    }
}

/** Nearest ancestor that can actually scroll (overflow + content taller than viewport). */
export function findScrollableAncestor(el: HTMLElement): HTMLElement | null {
    let parent = el.parentElement;
    while (parent) {
        const { overflowY } = getComputedStyle(parent);
        if (
            (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") &&
            parent.scrollHeight > parent.clientHeight + 1
        ) {
            return parent;
        }
        parent = parent.parentElement;
    }
    const root = (document.scrollingElement as HTMLElement | null) ?? document.documentElement;
    return root.scrollHeight > root.clientHeight + 1 ? root : null;
}

export function focusInputElementByName(name: string) {
    const byName = document.getElementsByName(name)[0] as HTMLElement | undefined;
    const el = byName ?? document.getElementById(name) ?? undefined;
    if (!el) {
        return;
    }

    if (document.activeElement) {
        (document.activeElement as HTMLElement).blur();
    }

    const input = el as HTMLInputElement;
    if (typeof input.focus === "function") {
        try {
            input.focus({ preventScroll: true });
        } catch {
            input.focus();
        }
    }

    const scrollTarget =
        input.type === "hidden" && el.parentElement ? el.parentElement : el;
    if (findScrollableAncestor(scrollTarget)) {
        scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" });
    }
}
